import {
    APPROVE_BBGT_ADMIN_PERMISSION,
    CONFIRM_BBGT_PERMISSION,
    DUYET_PHIEU_NHAP_PERMISSION,
    DUYET_PHIEU_XUAT_PERMISSION,
    PHIEU_NHAP_KHO,
} from "@/core/constants/permissions";
import { ButtonsType } from "@/core/enums/buttons.enums";
import ReportType from "@/core/enums/ReportTypes.enums";

const DocMenuConfig = [
  {
    pages: [
      {
        heading: "Trang chủ",
        route: "/trang-chu",
        svgIcon: "media/icons/duotune/art/art002.svg",
        disableLink: false,
        fontIcon: "bi-app-indicator",
      },
    ],
  },
  {
    heading: "Hệ thống",
    pages: [
      {
        heading: "Người dùng",
        route: "/quan-ly/nguoi-dung/danh-sach",
        svgIcon: "media/icons/duotune/communication/com006.svg",
        description: "Quản lý người dùng hệ thống",
        fontIcon: "bi-person",
        disableLink: false,
      },
      {
        heading: "Đơn vị",
        route: "/quan-ly/don-vi/danh-sach",
        svgIcon: "media/icons/duotune/general/gen001.svg",
        description: "Danh sách đơn vị và đồng bộ từ hệ thống kế toán",
        fontIcon: "bi-building",
        disableLink: false,
        capDonVi: [1],
      },
      {
        heading: "Cấu hình hệ thống",
        route: "/quan-ly/cau-hinh",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        description: "Cấu hình hệ thống",
        fontIcon: "bi-gear",
        disableLink: false,
      },
    ],
  },
  {
    heading: "Công ty quản lý",
    pages: [
      {
        sectionTitle: "Quản lý Cấp sửa chữa",
        route: "/quan-ly/cap-sua-chua/danh-sach",
        hiddenLink: "/quan-ly/cap-sua-chua/danh-sach",
        disableLink: false,
        description: "Quản lý Cấp sửa chữa",
        svgIcon: "media/icons/duotune/custom/wrench.svg",
        fontIcon: "bi-person",
        sub: [],
      },
      {
        sectionTitle: "Quản lý KHSC năm",
        route: "/quan-ly/ke-hoach-nam/danh-sach",
        description: "Danh sách kế hoạch sửa chữa năm",
        hiddenLink: "/quan-ly/ke-hoach-nam/danh-sach",
        svgIcon: "media/icons/duotune/general/gen055.svg",
        disableLink: false,
        fontIcon: "bi-person",
        requireDonViForCap1: true,
        sub: [],
      },
      {
        sectionTitle: "Quản lý KHSC tháng",
        route: "/quan-ly/ke-hoach-sua-chua/danh-sach",
        description: "Danh sách kế hoạch sửa chữa",
        hiddenLink: "/quan-ly/ke-hoach-sua-chua/danh-sach",
        svgIcon: "media/icons/duotune/general/gen055.svg",
        disableLink: false,
        fontIcon: "bi-person",
        requireDonViForCap1: true,
        sub: [],
      },
      {
        sectionTitle: "Quản lý ĐMCĐ",
        route: "/quan-ly/dinh-muc-co-dinh/danh-sach",
        hiddenLink: "/quan-ly/dinh-muc-co-dinh/danh-sach",
        description: "Quản lý ĐMCĐ",
        svgIcon: "media/icons/duotune/custom/up-to-line.svg",
        disableLink: false,
        fontIcon: "bi-person",
        sub: [],
      },
      {
        sectionTitle: "Toa xe",
        svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
        description: "Danh sách, chỉnh sửa và tạo mới toa xe",
        fontIcon: "bi-person",
        hiddenLink: "/quan-ly/toa-xe/danh-sach",
        disableLink: false,
        sub: [
          {
            heading: "Nhóm toa xe",
            route: "/quan-ly/danh-muc-toa-xe/danh-sach",
          },
          {
            heading: "Toa xe",
            route: "/quan-ly/toa-xe/danh-sach",
            requireDonViForCap1: true,
          },
        ],
      },
      {
        sectionTitle: "Vật tư",
        svgIcon: "media/icons/duotune/general/gen017.svg",
        description: "Danh sách, chỉnh sửa và tạo mới vật tư",
        disableLink: false,
        fontIcon: "bi-person",
        hiddenLink: "/quan-ly/vat-tu/danh-sach",
        sub: [
          {
            heading: "Quản lý Nhóm vật tư",
            route: "/quan-ly/danh-muc-vat-tu",
            readonlyForCap1: true,
          },
          {
            heading: "Quản lý Vật tư",
            route: "/quan-ly/vat-tu/danh-sach",
          },
        ],
      },
      {
        sectionTitle: "Phê duyệt",
        description: "Phê duyệt",
        isIconSvg: true,
        hiddenLink: "/duyet/danh-sach/vat-tu",
        disableLink: true,
        customIconName: ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_SOLID,
        sub: [
          {
            heading: "Bổ sung Vật tư (thêm)",
            route: "/duyet/danh-sach/vat-tu",
          },
          {
            heading: "Ngoài định mức",
            route: "/duyet/ngoai-dinh-muc",
          },
        ],
      },
      {
        sectionTitle: "Báo cáo",
        description: "Tổng hợp báo cáo công ty",
        hiddenLink: `/quan-ly/bao-cao/${ReportType.NHAP_XUAT_TON_KHO}`,
        disableLink: true,
        svgIcon: "media/icons/duotune/general/table-duotone.svg",
        fontIcon: "",
        capDonVi: [1],
        hidden: false, // TODO: in development — remove when ready
        sub: [
          {
            heading: "Nhập xuất tồn kho",
            route: `/quan-ly/bao-cao/${ReportType.NHAP_XUAT_TON_KHO}`,
            capDonVi: [1],
          },
          {
            heading: "T/hình nhập kho p.tùng",
            route: `/quan-ly/bao-cao/${ReportType.NHAP_KHO_VAT_TU_PHU_TUNG}`,
            capDonVi: [1],
          },
          {
            heading: "Giá thành SC các cấp",
            route: `/quan-ly/bao-cao/${ReportType.GIA_THANH_SUA_CHUA_CAC_CAP}`,
            capDonVi: [1],
          },
        ],
      },
    ],
  },
  {
    heading: "Đơn vị quản lý",
    pages: [
      {
        sectionTitle: "Quản lý Kho",
        route: "/quan-ly/kho/danh-sach",
        description: "Danh sách, chỉnh sửa và tạo mới kho",
        svgIcon: "media/icons/duotune/general/gen001.svg",
        disableLink: false,
        fontIcon: "bi-person",
        capDonVi: [2],
        sub: [],
        hiddenLink: "/quan-ly/kho/danh-sach",
      },
      {
        sectionTitle: "Quản lý nhập kho",
        route: "/quan-ly/nhap-kho/danh-sach",
        hiddenLink: "/quan-ly/nhap-kho/danh-sach",
        description: "Danh sách và tạo mới phiếu nhập kho",
        svgIcon: "media/icons/duotune/general/gen005.svg",
        disableLink: false,
        fontIcon: "bi-person",
        capDonVi: [2],
        perm: PHIEU_NHAP_KHO.XEM,
        sub: [],
      },
      {
        sectionTitle: "Quản lý Hợp đồng",
        route: "/quan-ly/hop-dong/danh-sach",
        hiddenLink: "/quan-ly/hop-dong/danh-sach",
        description: "Danh sách hợp đồng và các thông tin liên quan",
        svgIcon: "media/icons/duotune/general/gen005.svg",
        disableLink: false,
        fontIcon: "bi-person",
        capDonVi: [2],
        sub: [],
      },
      {
        sectionTitle: "Quản lý Biên bản giải thể",
        route: "/quan-ly/bien-ban-giai-the/danh-sach",
        description: "Danh sách biên bản giải thể",
        hiddenLink: "/quan-ly/bien-ban-giai-the/danh-sach",
        svgIcon: "",
        customIconName: ButtonsType.FA_FILE_CIRCLE_XMARK,
        disableLink: false,
        fontIcon: "",
        capDonVi: [2],
        sub: [],
      },
      {
        sectionTitle: "Phê duyệt",
        description: "Phê duyệt",
        isIconSvg: true,
        hiddenLink: "/duyet/danh-sach/phieu-nhap-kho",
        disableLink: true,
        customIconName: ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_SOLID,
        capDonVi: [2],
        sub: [
          {
            heading: "Phiếu nhập kho",
            route: "/duyet/danh-sach/phieu-nhap-kho",
            capDonVi: [2],
            perm: DUYET_PHIEU_NHAP_PERMISSION,
          },
          {
            heading: "Phiếu xuất kho",
            route: "/duyet/danh-sach/phieu-xuat-kho",
            capDonVi: [2],
            perm: DUYET_PHIEU_XUAT_PERMISSION,
          },
          {
            heading: "Biên bản giải thể",
            route: "/duyet/danh-sach/bien-ban-giai-the",
            capDonVi: [2],
            permAny: [CONFIRM_BBGT_PERMISSION, APPROVE_BBGT_ADMIN_PERMISSION],
          },
        ],
      },
      {
        sectionTitle: "Báo cáo",
        description: "Tổng hợp báo cáo đơn vị",
        hiddenLink: "/quan-ly/bao-cao",
        disableLink: true,
        svgIcon: "media/icons/duotune/general/table-duotone.svg",
        fontIcon: "",
        capDonVi: [2],
        sub: [
          {
            heading: "Sổ cân đối vật tư",
            route: `/quan-ly/bao-cao/${ReportType.SO_CAN_DOI_VAT_TU}`,
            capDonVi: [2],
          },
          {
            heading: "Bảng kê C/tiết nhập",
            route: `/quan-ly/bao-cao/${ReportType.BANG_KE_CHI_TIET_NHAP}`,
            capDonVi: [2],
          },
          {
            heading: "Bảng kê C/tiết xuất",
            route: `/quan-ly/bao-cao/${ReportType.BANG_KE_CHI_TIET_XUAT}`,
            capDonVi: [2],
          },
          {
            heading: "Tổng hợp nhập vật tư",
            route: `/quan-ly/bao-cao/${ReportType.TONG_HOP_NHAP_VAT_TU}`,
            capDonVi: [2],
          },
          {
            heading: "Tổng hợp xuất vật tư",
            route: `/quan-ly/bao-cao/${ReportType.TONG_HOP_XUAT_VAT_TU}`,
            capDonVi: [2],
          },
          {
            heading: "C/t xuất theo đối tượng",
            route: `/quan-ly/bao-cao/${ReportType.CHI_TIET_XUAT_THEO_DOI_TUONG}`,
            capDonVi: [2],
          },
          {
            heading: "T/dõi thực hiện hợp đồng",
            route: `/quan-ly/bao-cao/${ReportType.THEO_DOI_THUC_HIEN_HOP_DONG}`,
            capDonVi: [2],
          },
          {
            heading: "T/dõi VTPT thu hồi",
            route: `/quan-ly/bao-cao/${ReportType.THEO_DOI_VTPT_THU_HOI}`,
            capDonVi: [2],
          },
        ],
      },
    ],
  },
];

export default DocMenuConfig;
